import React from 'react'

const SvgProfessionalChatFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.638 10a2 2 0 00-2 2v6.065a2 2 0 002 2h5.386L22 22.005V12a2 2 0 00-2-2h-7.362zm5.981 8.065l1.38.902V12h-7.36v6.065h5.98z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.919 14.208c-.392.429-.524.842-.524 1.349v.686c-1.15.225-1.425 1.336-1.425 2.066v1.577c0 .34.279.614.623.614a.618.618 0 00.622-.614.616.616 0 00-.445-.589v-.988c0-.666.478-1.205 1.067-1.205.59 0 1.068.54 1.068 1.205v.988a.616.616 0 00-.446.589c0 .34.279.614.622.614a.618.618 0 00.623-.614v-1.577c0-.73-.275-1.841-1.425-2.067v-.685c0-.783.335-1.03.95-1.487l.073-.053.074-.004 1.262.02v4.032c.04.697.103.986.258 1.352A4.002 4.002 0 0012.638 22H3.97C2.657 22 2 21.333 2 20c0-3.256 1.306-5.187 3.919-5.792z'
    />
    <path d='M8.787 10.915A5.038 5.038 0 016.926 7c0-1.326.519-2.598 1.443-3.536A4.89 4.89 0 0111.852 2a4.89 4.89 0 013.483 1.464A5.038 5.038 0 0116.678 8h-4.04a4.002 4.002 0 00-3.85 2.915z' />
  </svg>
)

export default SvgProfessionalChatFilled
